export default __webpack_public_path__ + "2c7f626e929e620b03c2762a4bc644ef.png";